import Axios from 'axios';
import GeneralAction from '../Actions/GeneralAction';
import AuthAction from '../Actions/AuthActions';
import Apis from '../Apis';
import AlertAction from '../Actions/AlertActions';
import { getHeaders } from '../../utills';

class NotificationMiddleware {
  static getUserNotifications = () => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const {data} = await Axios.get(
            Apis.getUserNotificaions,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data?.data);
            dispatch(GeneralAction.HideLoading());
            
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static toggleNotifications = () => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const {data} = await Axios.get(
            Apis.updateNotificationSetting,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(
              AuthAction.NotificationSwitch(
                data?.data?.is_receive_notification,
              ),
            );
            // localStorage.setItem('@user', JSON.stringify(data?.data));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };
}

export default NotificationMiddleware;
